import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CLPAnnounce, CLPAnnounceResponse } from '../models/announcements.model';
import { SimpleResponse } from '../models/genericResponse.model';
import { delayedRetryHttp } from './shared/delayedRetry';
import { UtilityService } from './shared/utility.service';
import { EngageCreateInvoiceRequest } from '../models/engageforms-signup.model';
import { EngageCreateAccountRequest } from '../models/engageforms-signup.model';

@Injectable()
export class EngageInvoiceService {
  private baseUrl: string;
  private api: string = "api/EngageInvoice";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  async setupCLPCompany(encryptedUser: string, CLPCompanyID, BillingCLPUserID, isLoadBillingCLPUserID, eBLine): Promise<any | void> {
    const a = await this.httpClient
      .get<any>(`${this.baseUrl}/SetupCLPCompany/${CLPCompanyID}/${BillingCLPUserID}?isLoadBillingCLPUserID=${isLoadBillingCLPUserID}&eBLine=${eBLine}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "CLPCompanyID - " + CLPCompanyID + "," + "BillingCLPUserID - " + BillingCLPUserID + "," + "isLoadBillingCLPUserID - " + isLoadBillingCLPUserID + "," + "eBLine - " + eBLine, encryptedUser, "EngageInvoiceService", "setupCLPCompany"); });
    return a;
  }

  async updateAnnouncements(encryptedUser: string, clpAnnounce: CLPAnnounce): Promise<SimpleResponse | void> {
    const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/CLPAnnounce_Update`, clpAnnounce, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, clpAnnounce, "r - " + encryptedUser + " , " + "clpAnnounce - " + clpAnnounce, encryptedUser, "EngageInvoiceService", "updateAnnouncements") });
    return a;

  }

  async createInvoice(encryptedUser: string, EngageCreateInvoiceRequest: EngageCreateInvoiceRequest): Promise<any | void> {
    const a = await this.httpClient.post<any>(`${this.baseUrl}/CreateSOInvoice`, EngageCreateInvoiceRequest, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, EngageCreateInvoiceRequest, "r - " + encryptedUser, encryptedUser, "EngageInvoiceService", "createInvoice") });
    return a;

  }

  async engageProcessCharge(encryptedUser: string, selectedCLPCompanyID, eBLine, clpInvoiceID): Promise<any | void> {
    const a = await this.httpClient
      .get<any>(`${this.baseUrl}/EngageProcessCharge/${selectedCLPCompanyID}/${eBLine}/${clpInvoiceID}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "selectedCLPCompanyID - " + selectedCLPCompanyID + "," + "eBLine - " + eBLine + "," + "clpInvoiceID - " + clpInvoiceID, encryptedUser, "EngageInvoiceService", "engageProcessCharge"); });
    return a;
  }

  async emailSOInvoice(encryptedUser: string, clpInvoiceID, selectedCLPCompanyID, eBLine): Promise<any | void> {
    const a = await this.httpClient
      .get<any>(`${this.baseUrl}/EmailSOInvoice/${clpInvoiceID}/${selectedCLPCompanyID}/${eBLine}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpInvoiceID - " + clpInvoiceID + "," + "selectedCLPCompanyID - " + selectedCLPCompanyID  + "," + "eBLine - " + eBLine, encryptedUser, "EngageInvoiceService", "emailSOInvoice"); });
    return a;
  }

  async createSOAccount(encryptedUser: string, EngageCreateAccountRequest: EngageCreateAccountRequest): Promise<any | void> {
    const a = await this.httpClient.post<any>(`${this.baseUrl}/EngageCreateAccount`, EngageCreateAccountRequest, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, EngageCreateAccountRequest, "r - " + encryptedUser, encryptedUser, "EngageInvoiceService", "createSOAccount") });
    return a;
  }

  async bindDDBillingProfile(encryptedUser: string, selectedCLPCompanyID, eBLine): Promise<any | void> {
    const a = await this.httpClient
      .get<any>(`${this.baseUrl}/BindDDBillingProfile/${selectedCLPCompanyID}/${eBLine}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "selectedCLPCompanyID - " + selectedCLPCompanyID + "," + "eBLine - " + eBLine, encryptedUser, "EngageInvoiceService", "bindDDBillingProfile"); });
    return a;
  }

  async setupBillingProfile(encryptedUser: string, billingProfileID, selectedCompanyName, billingEmail): Promise<any | void> {
    const a = await this.httpClient
      .get<any>(`${this.baseUrl}/SetupBillingProfile/${billingProfileID}/${selectedCompanyName}/${billingEmail}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "billingProfileID - " + billingProfileID + "," + "selectedCompanyName - " + selectedCompanyName + "," + "billingEmail - " + billingEmail, encryptedUser, "EngageInvoiceService", "setupBillingProfile"); });
    return a;
  }
}
